import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "../base-service";
import { Agency } from "src/app/domain/agency";
import { catchError, finalize, map } from "rxjs/operators";

@Injectable({
    providedIn: 'root',
})
export class AgencyService extends BaseService {

    private serviceUrl = `${environment.GSServiceBaseUrl}api/agency`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getByPartner() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/ByPartner`, this.generateHeaderWithBearer(environment.GSBearer)).pipe(
            catchError(this.handleError<any>('getByPartner')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Agency[]) => {
                return response.map((item: Agency) => {
                    return Agency.mapFromJSON(item);
                });
            }));
    }
}